export default __webpack_public_path__ + "static/media/solar_pv_icon.fb64b500.svg";